import { Provider } from 'react-redux';
import { AppProps } from 'next/app';

import { selectCsrf } from '@r1-frontend/entities/stores/auth/selectors/selectCsrf';

import { useSendRequestByConnection } from '@r1-frontend/bp42/hooks';

import { wrapper } from './store/createStore';
import baseInitialProps from './baseInitialProps';
import bootstrap from './bootstrap';

bootstrap();

const DomRuApp = ({ Component, ...rest }: AppProps): JSX.Element => {
    const { store, props } = wrapper.useWrappedStore(rest);
    const { pageProps } = props;

    useSendRequestByConnection(selectCsrf(store.getState()));

    return (
        <Provider store={store}>
            <Component {...pageProps} />
        </Provider>
    );
};

DomRuApp.getInitialProps = baseInitialProps;

export default DomRuApp;
